import React from 'react';

const PermissionGroupMappingFormModal = React.lazy(() => import('../components/FormModal'));
const permissionGroupMappingModalRegistry = {
    core_permissionGroupMappingId: PermissionGroupMappingFormModal
};
export default permissionGroupMappingModalRegistry;
